import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { faDownload, IconDefinition } from '@fortawesome/free-solid-svg-icons';
import { FileType, GlobalFunctions } from 'globales-projekt-angular';
import { UserDatenEingabe } from 'src/app/data/user/user-daten-eingabe.model';
import { Betrieb } from 'src/app/data/ws/betrieb.model';
import { ErgSocKombi } from 'src/app/data/ws/erg-soc-kombi.model';
import { ErgSocSo } from 'src/app/data/ws/erg-soc-so.model';
import { PdfManipulation } from 'src/app/functions/pdf/pdf-manipulation.module';
import { ConstantsTableColsErgSocKombi } from 'src/app/immutable/table-cols/constants-table-cols-erg-soc-kombi';
import { ConstantsTableColsErgSocSo } from 'src/app/immutable/table-cols/constants-table-cols-erg-soc-so';

import { ApiService } from 'src/app/services/api.service';

@Component({
  selector: 'app-ergebnis-akkordeon-betrieb',
  templateUrl: './ergebnis-akkordeon-betrieb.component.html',
  styleUrls: ['./ergebnis-akkordeon-betrieb.component.css'],
})
export class ErgebnisAkkordeonBetriebComponent implements OnInit {
  showWaitingForDataSpinner: number = 0;
  faDownload: IconDefinition = faDownload;
  id: string;
  betrieb: Betrieb;
  userDatenEingabe: UserDatenEingabe;

  expanded: boolean = true;

  dataBetriebsgroesse: MatTableDataSource<ErgSocSo> =
    new MatTableDataSource();
  displayedColsBetriebsgroesse: string[] =
    ConstantsTableColsErgSocSo.getColumns();

  dataSocMerkmale: MatTableDataSource<ErgSocKombi> = new MatTableDataSource();
  displayedColsSocMerkmale: string[] =
    ConstantsTableColsErgSocKombi.getColumns();

  currentDate: Date = new Date();

  constructor(private apiService: ApiService) { }

  ngOnInit(): void { }

  onClickDownloadKlassifizierung() {
    let userDatenEingabeList: UserDatenEingabe[] = [];

    userDatenEingabeList.push(this.userDatenEingabe);
    this.showWaitingForDataSpinner++;

    this.apiService
      .postPdfBetriebe(userDatenEingabeList)
      .subscribe(async (response: Blob) => {

        const bytesLike = await PdfManipulation.writeGetDepseudonimisiertesPdf(response, this.betrieb.bezeichnung);
        const ab: ArrayBuffer = new Uint8Array(bytesLike as Uint8Array).buffer;

        this.downloadFile(ab);

        this.showWaitingForDataSpinner--;
      });
  }


  downloadFile(ab: ArrayBuffer) {
    const bezeichnung = this.betrieb?.bezeichnung?.trim();

    // Datum in Europe/Berlin als YYYYMMDD
    const parts = new Intl.DateTimeFormat("de-DE", {
      timeZone: "Europe/Berlin",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    }).formatToParts(new Date());

    const yyyymmdd =
      parts.find(p => p.type === "year")!.value +
      parts.find(p => p.type === "month")!.value +
      parts.find(p => p.type === "day")!.value;

    const namePart = bezeichnung && bezeichnung.length > 0 ? bezeichnung : "Unbekannter Betrieb";

    // Basename bauen
    const fileBaseNameRaw = `${yyyymmdd}-${namePart}`;

    // Windows-unsafe Zeichen entfernen + Whitespace normalisieren
    const safeFileBaseName = fileBaseNameRaw
      .replace(/[\\/:*?"<>|]+/g, "_")
      .replace(/\s+/g, " ")
      .trim();

    // Länge begrenzen (ohne Extension)
    const MAX_LEN = 120;
    const safeFileBaseNameLimited =
      safeFileBaseName.length > MAX_LEN ? safeFileBaseName.slice(0, MAX_LEN).trim() : safeFileBaseName;

    GlobalFunctions.downloadFile(
      FileType.PDF.toString(),
      ab,
      safeFileBaseNameLimited,
      FileType.PDF_SHORT
    );


  }
}
